import React, { Component } from "react";
import HelpMenu from "../../containers/HelpMenuContainer";
import { currentLocals } from "../../languages/languages.js";
import { SupportedLocale } from "@lectra/mui-library";
import { MuiHeader, MuiParametersPopup } from "@lectra/mui-library";
import Cookies from "universal-cookie";
import CRUDAccess from "../../containers/CRUDAccessContainer.js";
import { AuthenticationProvider } from "@lectra/react-authentication";
import { useAuthenticationValue } from "@lectra/react-authentication";
import { RedirectToLogin } from "@lectra/react-authentication";
import { MuiMessageBox } from "@lectra/mui-library";

export default class HeaderMui extends Component {
  constructor(props) {
    super(props);
    this.state = { isPreferencesPopupOpened: false, bShowWarningAdmin: false }; // Nueva var de state bShowWarningAdmin

    this.SelectDiscovery = this.SelectDiscovery.bind(this);
    this.SelectWhatsIsNew = this.SelectWhatsIsNew.bind(this);

    this.setPreferencesPopupOpen = this.setPreferencesPopupOpen.bind(this);
    this.setConvertersConfigPopupOpen = this.setConvertersConfigPopupOpen.bind(this);
    this.getLanguageItems = this.getLanguageItems.bind(this);
    this.handleShowConvertersmanager = this.handleShowConvertersmanager.bind(this);
    this.SetNoEditOnConverters = this.SetNoEditOnConverters.bind(this);

    // vesion control
    /*
    const cookies = new Cookies();
    let noMoreWelcome = cookies.get("noMoreWelcome");
    let PaCoVersion = cookies.get("PaCoVersion");
    // to show "What's New" when a new version is deployed
    if (PaCoVersion !== "2022.06.02") {
      if (noMoreWelcome === "3") cookies.set("noMoreWelcome", "2", { path: "/" });
    }
    // set version
    cookies.set("PaCoVersion", "2022.06.02", { path: "/" });
    */
    //State variables
    //this.state = { isPreferencesPopupOpened: false };
  }
  FunctionsAfterLoad() {}

  SelectDiscovery() {
    let IdDiscoveryTour = document.getElementById("theDiscoveryTour");
    IdDiscoveryTour.click();
  }

  SelectWhatsIsNew() {
    let Idthewhatisnew = document.getElementById("thewhatisnew");
    Idthewhatisnew.click();
  }

  setPreferencesPopupOpen(mostrar) {
    /*
    const { setIsPreferencesPopupOpened } = this.props;
    setIsPreferencesPopupOpened(mostrar);
    */

    this.setState({ isPreferencesPopupOpened: mostrar });
  }
  setConvertersConfigPopupOpen(mostrar) {
    const { setIsConvertersConfigPopupOpened } = this.props;
    setIsConvertersConfigPopupOpened(mostrar);
  }

  getLanguageItems(t) {
    let languageItems = [
      {
        label: "English",
        value: SupportedLocale.EN,
      },
      {
        label: "Français",
        value: SupportedLocale.FR,
      },
      {
        label: "Italiano",
        value: SupportedLocale.IT,
      },
      {
        label: "Português",
        value: SupportedLocale.PT,
      },
      {
        label: "Español",
        value: SupportedLocale.ES,
      },
      {
        label: "Deutsch",
        value: SupportedLocale.DE,
      },
      {
        label: "日本語 ",
        value: SupportedLocale.JA,
      },
      {
        label: "中文",
        value: SupportedLocale.ZH,
      },
    ];

    return Object.values(languageItems).map((item) => ({
      ...item,
    }));
  }
  handleShowConvertersmanager = () => {
    var x = document.getElementsByClassName("ToolbarManagerContainer");
    var i;
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "";
    }

    let convertermanager = document.getElementById("convertermanager");
    convertermanager.style.width = "500px";
    convertermanager.style.visibility = "hidden";

    let op = 0.1;
    let timer = setInterval(fadeIn, 5);
    function fadeIn() {
      convertermanager.style.visibility = "visible";
      if (op >= 0.95) {
        clearInterval(timer);
      }
      convertermanager.style.opacity = op;
      op += op * 0.5;
    }
  };

  OnOkHideWarningdAdmin() {
    this.setState({ bShowWarningAdmin: false });
  }

  AdminAndConvertersManagerOpen = (enter) => {
    // enter: parámetro que indica
    const { setEnableCRUD } = this.props;

    if (this.props.permissions.includes("PCONV:pconv:admin")) {
      this.setState({ bShowWarningAdmin: false });
      setEnableCRUD(true);
    } else {
      if (enter === true) {
        this.setState({ bShowWarningAdmin: true });
        if (!this.props.enableCRUD); //this.OpenCRUDAccessMenu(true);
        else setEnableCRUD(false);
      }
    }
    if (enter === false) setEnableCRUD(false);
  };

  OpenCRUDAccessMenu(open) {
    let CRUDAccess = window.document.getElementById("CRUDAccess");

    if (open === false) {
      CRUDAccess.classList.remove("open");
    } else {
      if (this.props.enableCRUD === false) {
        if (CRUDAccess.classList.contains("open"));
        else {
          CRUDAccess.classList.add("open");
        }
      } else {
        CRUDAccess.classList.remove("open");
        const { setEnableCRUD } = this.props;
        setEnableCRUD(false);
        this.SetNoEditOnConverters();
      }
    }
  }

  SetNoEditOnConverters() {
    //var x = document.getElementsByClassName("convertername");
  }
  OpenLoginout = () => {
    let Loginout = window.document.getElementById("Loginout");
    if (Loginout.className === "dropdown btn-group") Loginout.className = "dropdown open btn-group";
    else Loginout.className = "dropdown btn-group";
  };
  CloseLoginout = () => {
    let Loginout = window.document.getElementById("Loginout");
    Loginout.className = "dropdown btn-group";
  };
  ClearUserInLogout = () => {
    //const authdata = useAuthenticationValue();
    //let nom = authdata.user;
    //alert(nom);
  };

  render() {
    //console.log("Main->Parametro conectado, desde el Main " + this.props.connected);
    //Decidimos, en base a las cookies, si mostramos , WhatIsNew....
    //const t = this.useTranslate();

    const REACT_APP_MYLECTRA =
      window.process !== undefined ? window.process.env.REACT_APP_MYLECTRA : process.env.REACT_APP_MYLECTRA;
    // alert(REACT_APP_MYLECTRA);

    const { logout } = this.props;
    const appTitle = {
      label: "Pattern Converter",
    };
    const userProfile = {
      user: {
        firstName: this.props.firstName || "",
        lastName: this.props.lastName || "",
        email: this.props.mail,
      },
      userProfile: {
        link: REACT_APP_MYLECTRA + "/profile",
      },
      myLectra: {
        link: REACT_APP_MYLECTRA,
      },
      logoutAction: () => {
        logout();
        this.ClearUserInLogout();
      },
    };
    let preferences;
    let thisnoaccess;
    if (this.props.authnoaccess === false) {
      if (!this.props.enableCRUD) {
        preferences = {
          preferencesAction: () => this.setPreferencesPopupOpen(true),

          externalLinks: [
            /*{
            label: currentLocals(this.props.locale).preferences.Configuration,
            link: "",
            hideIcon: true,

            navigateToLink: () => this.props.setConvertersManagerOpen(true),
          },*/
            {
              label: currentLocals(this.props.locale).preferences.AdminUserEnter,
              link: "",
              hideIcon: true,
              navigateToLink: () => this.AdminAndConvertersManagerOpen(true),
            },
          ],
        };
      } else {
        preferences = {
          preferencesAction: () => this.setPreferencesPopupOpen(true),

          externalLinks: [
            {
              label: currentLocals(this.props.locale).preferences.Configuration,
              link: "",
              hideIcon: true,

              navigateToLink: () => this.props.setConvertersManagerOpen(true),
            },
            {
              label: currentLocals(this.props.locale).preferences.AdminUserExit,
              link: "",
              hideIcon: true,
              navigateToLink: () => this.AdminAndConvertersManagerOpen(false), // añadir false..> (setEnableCRUD(false);(
            },
          ],
        };
      }
    }
    const { SetLocale } = this.props;

    return (
      <div>
        <div style={{ visibility: "hidden", display: "none" }}>
          <HelpMenu locale={this.props.locale}></HelpMenu>
        </div>
        <MuiMessageBox
          // warning message  about the role of Converter Administrator.

          open={this.state.bShowWarningAdmin}
          //open={true}
          alertType="warning"
          title={currentLocals(this.props.locale).MessagesBoxAdmin.ConverterAdministrator_title}
          content={currentLocals(this.props.locale).MessagesBoxAdmin.ConverterAdministrator_content}
          lang={this.props.locale}
          onClose={function noRefCheck() {}}
          primaryButton={{
            color: "primary",
            label: currentLocals(this.props.locale).preferences.OK,
            onClick: () => this.OnOkHideWarningdAdmin(),
          }}
        />
        <div>
          <MuiParametersPopup
            lang={this.props.locale}
            open={this.state.isPreferencesPopupOpened}
            onClose={() => this.setPreferencesPopupOpen(false)}
            items={[
              {
                title: currentLocals(this.props.locale).preferences.Language_and_Region,

                parameters: [
                  {
                    label: currentLocals(this.props.locale).preferences.Language,
                    value: this.props.locale,
                    onChange: (locale) => SetLocale(locale),
                    type: "single_value",
                    items: this.getLanguageItems(),
                    "data-tut": "reactour__convertersadmin",
                  },
                ],
              },
            ]}
          />{" "}
        </div>

        <div style={{ display: "flex" }}>
          <MuiHeader
            lang={this.props.locale}
            appTitle={appTitle}
            userProfileProps={userProfile}
            preferencesProps={preferences}
            helpMenuProps={{
              guidedTour: {
                action: () => {
                  this.SelectDiscovery();
                },
              },
              whatsNew: {
                action: () => {
                  this.SelectWhatsIsNew();
                },
              },
              learningCenter: {
                link: "https://knowledgecenter.mylectra.com/pattern-converter#news",
              },
              /*
              myLectraSupport: {
                link: "https://www.mylectra.com/s/case/Case/Recent",
              },
              privacyPolicies: {
                link: "https://www.lectra.com/en/privacy-policy",
              },*/
            }}
          />
        </div>
        <CRUDAccess></CRUDAccess>
      </div>
    );
  }
}
